import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_EVENTOS = 'ALL_EVENTOS';
export const ACTIVO_EVENTOS = 'ACTIVO_EVENTOS';
export const LOADING_ALL_EVENTOS = 'LOADING_ALL_EVENTOS';
export const PARAMS_EVENTOS = 'PARAMS_EVENTOS';
export const SLOTINFO_EVENTOS = 'SLOTINFO_EVENTOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
  slotInfo: null,
};

export const reportesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_EVENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_EVENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SLOTINFO_EVENTOS:
      return {
        ...state,
        slotInfo: action.payload,
      };
    case LOADING_ALL_EVENTOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_EVENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
